import * as React from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ModuleReports } from "../../Common/Services/ModuleReports";

export class FacilitiesWoStatus extends React.Component<any, any> {


  // private summarySubTypes = [
  //   { label: "All", value: "0" },
  //   { label: "Completed", value: "Completed" },
  //   { label: "In Progress", value: "In Progress" },
  //   { label: "On Hold", value: "On Hold" },
  // ];



  constructor(props: any) {
    super(props);
    
    this.state = {
      // selectedItem: { label: "All", value: "0" },
      // summarySubTypes: this.summarySubTypes,
      selectedItem:[],
      summarySubTypes: [],
    };
  }




  GetFacilitiesMultiPMSchedule = async (hotelIds: number) => {
  
    try {
      const result: any[] = await ModuleReports.GetFacilityReportDropdownDetails(hotelIds.toString(),"FCWodllStatus");
      if (result?.length > 0) {
     
debugger;
        this.setState({ summarySubTypes: result, selectedItem:[]},()=>{
          //this.handleDropdownChange(this.state.selectedItem);
          //this.props?.handelResponseStatus(result[0].value);
          if(this.props?.FCWoStatus==="" || this.props?.FCWoStatus===undefined) 
          {        
          this.props?.handelResponseStatus(result[0].value);
          }else{            
            const rowIndex = this.state.summarySubTypes.findIndex(
              (obj) =>
                obj?.lable?.toLowerCase().trim() ===
                this.props?.FCWoStatus.toLowerCase().trim()
            );
            this.setState({ selectedItem: this.props?.FCWoStatus });
            this.props?.handelResponseStatus(result[rowIndex].value);
            
          }




        });


      }
    } catch (error) {
      // Need to handle this
      console.log(error);
    }
  };


  componentDidMount = () => {
    
    // const { defaultValue } = this.props;
    // if (defaultValue === "Yes") {
    //   this.handleDropdownChange({
    //     label: "All",
    //     value: "0",
    //   });
    // } else {
    //   this.handleDropdownChange(this.state.selectedItem);
    // }

    debugger;
    const { hotelIds } = this.props;    
   this.GetFacilitiesMultiPMSchedule(hotelIds);

  };
  componentDidUpdate = (prevProps:any) => {
  
    if (this.props?.FCWoStatus==="") {
      this.GetFacilitiesMultiPMSchedule(this.props?.hotelIds);
    }
  
  };

  handleDropdownChange = (item: any) => {
    this.setState({ selectedItem: item?.lable });
    this.props?.handelResponseStatus(item.value);
   
  };
   


  render() {

    return (
      <Dropdown className="single-select">
        <Dropdown.Toggle id="Modal-empType">
          <span
              style={{
                width: "95%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
             {this.state.selectedItem.length===0 ? this.state.summarySubTypes[0]?.lable:this.state.selectedItem}
            </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="list-area">
            {this.state.summarySubTypes.map((item: any, idx: any) => (
             
                <Dropdown.Item onClick={() => this.handleDropdownChange(item)}>
                  {item.lable}
                </Dropdown.Item>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

